import React from "react";
import Announcements from "../components/Announcements";
import "./StudentComunicados.css";

/**
 * Full-page comunicados for students (replaces narrow right sidebar panel).
 */
function StudentComunicados() {
  return (
    <div className="student-comunicados-page">
      <header className="student-comunicados-header">
        <h1>Comunicados</h1>
        <p>Consulta los avisos y novedades de tu academia.</p>
      </header>
      <div className="student-comunicados-panel">
        <Announcements variant="page" />
      </div>
    </div>
  );
}

export default StudentComunicados;
